import { useTranslation } from "react-i18next";

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-background-50">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Minimalist%20editorial%20fashion%20photography%20featuring%20carefully%20arranged%20luxury%20streetwear%20items%20on%20cream%20marble%20surface%20pristine%20white%20premium%20sneakers%20folded%20beige%20cashmere%20sweater%20and%20structured%20leather%20tote%20bag%20soft%20diffused%20studio%20light%20casting%20gentle%20shadows%20clean%20modern%20composition%20with%20ample%20negative%20space%20warm%20neutral%20color%20palette%20high%20end%20magazine%20quality%20European%20aesthetic&width=1600&height=900&seq=hero-bg-v2-001&orientation=landscape"
          alt="CSSBuy Spreadsheet - Streetwear Editorial"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 pt-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-7xl mx-auto">
          {/* Left Text Column */}
          <div className="w-full lg:w-5/12 flex flex-col items-start">
            <h1 className="text-foreground-50 dark:text-foreground-950">
              <span className="block text-4xl md:text-5xl lg:text-6xl font-bold font-heading tracking-tight leading-tight">
                {t("hero.title_line1")}
              </span>
              <span className="block text-5xl md:text-6xl lg:text-7xl font-heading italic font-medium text-accent-300 mt-1 leading-tight">
                {t("hero.title_line2")}
              </span>
            </h1>

            <p className="mt-6 text-base md:text-lg text-background-100 max-w-lg leading-relaxed">
              {t("hero.subtitle")}
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-3 mt-8">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-8 py-3.5 bg-primary-500 text-background-50 font-medium text-sm rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer text-center"
              >
                {t("hero.cta1")}
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-8 py-3.5 border border-background-100/40 text-background-50 font-medium text-sm rounded-full hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer text-center"
              >
                {t("hero.cta2")}
              </a>
            </div>

            {/* Trust Badges */}
            <div className="flex flex-wrap gap-x-6 gap-y-2 mt-8">
              {["hero.trust1", "hero.trust2", "hero.trust3", "hero.trust4"].map((key) => (
                <span key={key} className="text-xs text-background-100/80 flex items-center gap-1">
                  {t(key)}
                </span>
              ))}
            </div>
          </div>

          {/* Right Visual Column */}
          <div className="w-full lg:w-7/12 flex justify-end">
            <div className="relative w-full max-w-xl aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20flat%20lay%20photography%20featuring%20premium%20olive%20green%20bomber%20jacket%20draped%20elegantly%20beside%20cream%20leather%20sneakers%20and%20minimalist%20silver%20watch%20on%20textured%20linen%20fabric%20soft%20morning%20light%20streaming%20through%20sheer%20curtains%20creating%20warm%20ambient%20glow%20sophisticated%20streetwear%20aesthetic%20with%20organic%20textures%20refined%20composition%20magazine%20editorial%20quality&width=1200&height=900&seq=hero-product-v2-002&orientation=landscape"
                alt="CSSBuy Streetwear Collection"
                className="w-full h-full object-cover rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}